var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section",class:{'is-padded': _vm.isPadded, 'has-title': _vm.title, 'is-divided': _vm.isDivided, 'is-grow': _vm.grow}},[(_vm.title)?_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }